"use client";

import { useHasParentAccount } from "@packages/kids";
import { useIsKidAccount } from "@packages/sdk";
import { showModal } from "@packages/ui";
import { useEffect } from "react";

import { AccessRestrictedModal } from "../components/AccessRestrictedModal";

type UseAccessRestrictedGuardOptions = {
  restricted: boolean;
};

export const useAccessRestrictedGuard = ({
  restricted,
}: UseAccessRestrictedGuardOptions): { isRestricted: boolean } => {
  const { isKidAccount } = useIsKidAccount();
  const hasParentAccount = useHasParentAccount();

  const wouldSwitchingProfilesHelp = isKidAccount && hasParentAccount;

  useEffect(() => {
    if (!restricted) return;
    showModal(AccessRestrictedModal, {
      wouldSwitchingProfilesHelp,
    });
  }, [wouldSwitchingProfilesHelp, restricted]);

  return { isRestricted: restricted };
};
